import { useState, useEffect, useRef } from "react";
import { useHistory,useParams } from "react-router-dom";
import {
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import {usermanageService} from '../../../services/usermanageService';
import "assets/css/themecustom-style.css";
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';

const KROListing = (props) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);
  const [krodata, setKROdata] = useState([]);
  const [fullloader,setLoader] = useState(false);
  const months = [{value:'01',label : 'Jan'},{value:'02',label :'Feb'},{value:'03',label :'March'},{value:'04',label :'April'},{value:'05',label :'May'},{value:'06',label :'June'},{value:'07',label :'July'},{value:'08',label :'Aug'},{value:'09',label :'Sept'},{value:10,label :'Oct'},{value:11,label :'Nov'},{value:12,label :'Dec'}];
  const [monthdata, setmonthdata] = useState(months);
  
  const [statuslist, setStatusdata] = useState([]);
const [reviewerlist, setReviewerData] = useState([]);
  const [uniqueuserslist, setUniqueUsersData] = useState([]);
  const [filtertype,setfiltertype] = useState('not_eligible');
  const user_info = JSON.parse(localStorage.getItem("user-info"));
const initialData = {
  user_id : '',
  month_year : '',
  reviewer_id : '',
  status : ''
}
const [inputFields, setInputfields] = useState(initialData);
  function get_unique_userslist(){
    usermanageService.getusersforchatbox().then((response)=>{
      setUniqueUsersData(response.data.users);
    });
  }
  function get_status_list() {
    usermanageService.krogetstatus().then((response) => {
      setStatusdata(response.data.status);
    });
  }
  const history = useHistory();
  const handlePageClick = (e, index) => {
    e.preventDefault();
    get_kro_list(index);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_kro_list(prev);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_kro_list(next);
  };

  const get_kro_list = async (pageNumber = 1,e,sortfield,sortorder,filtertype='') => {
  
    usermanageService.getkrolist(pageNumber,inputFields,sortfield,sortorder,filtertype).then((response) => {
      setKROdata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setLastPageData(response.data.data.last_page);
      setReviewerData(response.data.reviewer_arr)
    });
  };
  const addkro = ()=>{
    history.push("/admin/krocalculation/");
  }
  const noteligibleuser = ()=>{
    history.push("/admin/noteligibleuser/");
  }
  const editclick = (user_id,month_year) => {
    // history.push("/admin/krocalculation/"+user_id+"/"+month_year);
     const url = "/admin/krocalculation/" + user_id + "/" + month_year;
    window.open(url, "_blank");  // Opens in a new window or tab
    
  }
  function inputhandler1(e,field) {
    if(field=='month_year'){
      setInputfields((prevInputFields)=>({ ...prevInputFields, [field]: e.target.value } ));
    }else{
    setInputfields((prevInputFields) => ({
      ...prevInputFields,
      [field]: e.value,
    }));
    }
  
  }

  const editField = (value, field, id,user_id, index) => {
    let temp_st = [...krodata];
    let temp_ele = { ...temp_st[index] };
   
    if((field == 'approval' || field == "manager_approval") && value == 2){
      // if reject then remarks should not be blank
      if(temp_ele.remarks == '' || temp_ele.remarks == null){
        toast.error('Remarks is required');
        return;
      }
    }
    usermanageService.editKRORow(value, field, id,user_id).then((response) => {
   
      if(response.status == 200){
          if (field == "approval") {
            if (value == 1) {
              temp_ele.approval = "Discussed & Approved";
            } else if (value == 2 && temp_ele.status != 17) {
              temp_ele.approval = "Rejected";
              temp_ele.status_name = "Not Complete";
            }else{
              temp_ele.approval = "";
            }
          }

          if (field == "manager_approval") {
            if (value == 1) {
              temp_ele.manager_approval = "Discussed & Approved";
            } else if (value == 2 && temp_ele.status != 17) {
              temp_ele.manager_approval = "Rejected";
              temp_ele.status_name = "Not Complete";
            }else{
              temp_ele.manager_approval = "";
            }
          }
         
          toast.success(response.data.message);
          temp_ele[field] = value;
         
      }else{
          toast.error(response.data.message);
      }
    temp_ele.mainediting = false;
     temp_st[index] = temp_ele;
     setKROdata(temp_st);
    });
  };

  const handlemaineditRow = (index) => {
      let temp_state = [...krodata];
      let temp_element = { ...temp_state[index] };
      temp_element.mainediting = true;
      temp_state[index] = temp_element;
      setKROdata(temp_state);
  };
   // sorting functon
   const [sortfield,setsortfield] = useState('');
   const [sortorder,setsortorder] = useState('asc');
   function sortTable(field){
     console.log(field)
     setsortfield(field);
     if(sortorder=='asc'){
       setsortorder('desc');
     }else{
       setsortorder('asc');
     }
   }
   
 useEffect(() => {
 get_unique_userslist();
   get_kro_list();
   get_status_list();
   get_kro_statstics_data();
 }, [sortorder]);

 const isFirstRender = useRef(true);
 useEffect(() => {
   if (isFirstRender.current) {
     isFirstRender.current = false;
     return;
   }
   get_kro_list();
 }, [inputFields]);

 const[countData,setCountData] = useState([]);
 const get_kro_statstics_data = ()=>{
   
   usermanageService.KROCountData(inputFields).then((response) => {
     setCountData(response.data.data);
   });
 }
   const archieveRows = (e,id,flag,user_id,month_year) => {
    e.preventDefault();
    swal({
      title: "Are you sure want to remove?",
      text: "",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((isConfirm) => {
      if (isConfirm){
    usermanageService.deleteKro(id,user_id,month_year).then((response) => {
      if(response.status == 200){
       
        get_kro_list();
       toast.success(response.data.message);
        
       
      }else{
        toast.error(response.data.message);
      }
    });
  }
});
  }
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
      <Row className="align-items-center row">
            <Col xl="10">
        <Button className="dash-button "
                color="primary"
                type="button"
                onClick={addkro}>
           Add monthly KRO
        </Button>
      </Col>
      {/* <Col xl="2">
        <Button className="dash-button "
                color="secondary"
                type="button"
                onClick={noteligibleuser}>
           Not Eligible Users
        </Button>
     </Col> */}
   
     
     </Row>
     <Row className="dash-analy">
               <Col xl="2" md="6" xs="12"  className="dash-col-analy dash-col-analy-2" >
                
                     <Row className={(filtertype=='not_eligible' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                       <div className="col" onClick={() => {get_kro_list(1,null,'','','not_eligible'),setfiltertype('not_eligible')}}>
                         <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                           Not Eligible
                         </h6>
                         <h1 style={{ color: "#0060B8" }}>
                           {countData.not_eligible}
                         </h1>
                         <h3 className="mb-0" style={{ color: "#0060B8" }}>
                         Not Eligible
                         </h3>
                       </div>
                     </Row>
                  
               </Col>
               <Col xl="2" md="6" xs="12"  className="dash-col-analy dash-col-analy-2" >
                
                     <Row className={(filtertype=='pending' ? "align-item-s-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                       <div className="col" onClick={() => {get_kro_list(1,null,'','','pending'),setfiltertype('pending')}}>
                         <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                           Pending
                         </h6>
                         <h1 style={{ color: "#FF1717" }}>
                           {countData.pending}
                         </h1>
                         <h3 className="mb-0" style={{ color: "#FF1717" }}>
                           Pending 
                         </h3>
                       </div>
                     </Row>
                  
               </Col>
               <Col xl="2" md="6" xs="12" className="dash-col-analy dash-col-analy-2">
                 {/* <Card className="shadow">
                   <CardHeader className="bg-transparent"> */}
                     <Row  className={(filtertype=='overdue' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                       <div className="col" onClick={() => {get_kro_list(1,null,'','','completed'),setfiltertype('completed')}}>
                         <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                         Completed
                         </h6>
                         <h1 style={{ color: "#FF8C00" }}>
                           {countData.completed}
                         </h1>
                         <h3 style={{ color: "#FF8C00" }} className="mb-0">
                         Completed
                         </h3>
                       </div>
                     </Row>
                   {/* </CardHeader>
                 </Card> */}
               </Col>
             
               <Col xl="2" md="6" xs="12" className="dash-col-analy dash-col-analy-2">
                  <Row  className={(filtertype=='completed' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                       <div className="col" onClick={() => {get_kro_list(1,null,'','','pending_for_reviewer_approval'),setfiltertype('pending_for_reviewer_approval')}}>
                         <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                           Pending For Reviewer Approval
                         </h6>
                         <h1 style={{ color: "#0DAF84" }}>
                           {countData.pending_for_reviewer_approval}
                         </h1>
                         <h3 style={{ color: "#0DAF84" }} className="mb-0">
                         Pending For Reviewer Approval 
                         </h3>
                       </div>
                     </Row>
                
               </Col>
               <Col xl="2" md="6" xs="12"className="dash-col-analy dash-col-analy-2">
                   <Row  className={(filtertype=='urgent' ? "align-items-center dash-inner-row active" : "align-items-center dash-inner-row")}>
                       <div className="col" onClick={() => {get_kro_list(1,null,'','','pending_for_approval'),setfiltertype('pending_for_approval')}}>
                         <h6 className="text-uppercase text-muted text-dash ls-1 mb-1">
                           Pending For Approval
                         </h6>
                         <h1 style={{ color: "#FF1717" }}>
                           {countData.pending_for_approval}
                         </h1>
                         <h3 style={{ color: "#FF1717" }} className="mb-0">
                         Pending For Approval 
                         </h3>
                       </div>
                     </Row>
               </Col>
              
             </Row>
        <Row className="mt-5">
          <div className="col" style={{ padding: "0%" }}>
            <Card className="shadow">
              <CardHeader className="border-0">
              <Row className="filter" style={{padding:'0 1%'}}>
               {/* <div className="filter" style={{width:'100%'}}> */}
                   <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select User</h3>
                   {(uniqueuserslist.length > 0) ? 
                   <Select 
                   
                   className="input-group-alternative mb-3" 
                   name="user_id"
                   options={uniqueuserslist} // set list of the data
                   onChange={(e) => inputhandler1(e,'user_id')}
                  //  value={usersearch}
                   searchable
                   isClearable={false}
                 />
                 : null }
                  </div>
                  <div className="col-xl-2 col-md-3 col-xs-12">
                      <h3 className="clientformtag"> Select Reviewer</h3>
                      <Select 
                        className="input-group-alternative mb-3" 
                        name="reviewer_id"
                        options={reviewerlist} // set list of the data
                        onChange={(e) => inputhandler1(e,'reviewer_id')}
                        searchable
                        isClearable={false}
                    />
                   </div>
                   <div className="col-xl-2 col-md-3 col-xs-12">
                      <h3 className="clientformtag"> Select Status</h3>
                      <Select 
                        className="input-group-alternative mb-3" 
                        name="reviewer_id"
                        options={statuslist} // set list of the data
                        onChange={(e) => inputhandler1(e,'status')}
                        searchable
                        isClearable={false}
                    />
                   </div>
                  <div className="col-xl-2 col-md-3 col-xs-12">
                    <h3 className="clientformtag"> Select month</h3>
                    <input type="month"
                                      className="form-control"
                                      name="month_year"
                                      onChange={(e) => { inputhandler1(e,'month_year')}}
                                      value={inputFields.month_year}
                                      options={monthdata}
                                      required
                                      />
                                       {inputFields.month_year && <div style={{ marginTop: 20, lineHeight: '25px' }}></div>}
                      
                                  </div>
                  
                                  
                    <div className="col-xl-3 col-md-3 col-xs-12">
                    <br></br>
                      <Button className="col-xl-6 btn btn-primary"  onClick={(e) => get_kro_list()}>Search</Button>
                    </div>
                    {/* </div> */}
                </Row>
                <Row className="filter" style={{ padding: "0 25px" }}>
                  <h3 className="mb-0" style={{ fontSize: "20px" }}>
                    KRO's
                  </h3>
                  <br></br>
                  <br></br>
                </Row>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <th scope="col">Name</th>
                  <th scope="col">Reviewer</th>
                  <th scope="col">Month</th>
                  <th scope="col" className="whitespace sortclass" onClick={(e) => sortTable('total_weightage_score')}>Score</th>
                  <th scope="col" className="whitespace sortclass" onClick={(e) => sortTable('total_weightage_score')}>Rating</th>
                  <th scope="col">Status</th>
                  <th scope="col">R. Approval</th>
                  <th scope="col">M. Approval</th>
                  <th scope="col">Remarks</th>
                  <th scope="col">Action</th>
                </thead>
                <tbody>
                  {krodata && krodata.length && krodata != null ? (
                    krodata.map((item, i) =>
                      item != undefined ? (
                        <>
                          <tr
                            className={
                              item.total_weightage_score <= 2.5
                                ? "purple-row"
                                : (item.total_weightage_score <= 3.5 && item.total_weightage_score > 2.5)
                                ? "blue-row"
                                : "orange-row"
                            }
                          >
                            <td>{item.name}</td>
                            {/* <td>{item.email}</td> */}
                            <td>{item.reviewer}</td>
                            <td>{item.month}</td>
                            <td>{item.total_weightage_score}</td>
                            {/* {item.department == 'SME' ? 
                            <td>{(item.total_weightage_score == '' || item.total_weightage_score == null) ? '' : (item.total_weightage_score <= 1 ? "Needs Action" : (item.total_weightage_score <= 2.9 ? "Below Expectations" : (item.total_weightage_score <= 3.9 ? "Meets Expectations" : (item.total_weightage_score <= 4.9 ? "Exceed Expectation" : (item.total_weightage_score <= 5 ? "Exceptional" : "")) )))}</td>
                            : */}
                            <td>{(item.total_weightage_score == '' || item.total_weightage_score == null) ? '' : (item.total_weightage_score <= 1 ? "Needs Action" : (item.total_weightage_score <= 2.5 ? "Below Expectations" : (item.total_weightage_score <= 3.5 ? "Meets Expectations" : (item.total_weightage_score <= 4.5 ? "Exceed Expectation" : (item.total_weightage_score <= 5 ? "Exceptional" : "")) )))}</td>
                            {/*  } */}
                            <td>{item.status_name}</td>
                            {(item.approval != 1 && item.approval != 2 && (item.status == 3 || item.status == 17) && item.reviewer_id == user_info.id) ?
                            (<td>
                              <Button
                                color="primary"
                                style={{
                                  background: "#02C779",
                                  border: "#02C779",
                                  borderRadius: "18px",
                                }}
                                size="sm"
                                type="button"
                                onClick={(e) =>
                                  editField(
                                    1,
                                    "approval",
                                    item.month_ye,
                                    item.user_id,
                                    i
                                  )
                                }
                              >
                                Approve
                              </Button>
                             
                              <Button
                                color="primary"
                                style={{
                                  border: "1px solid #FF6430",
                                  background:'none',
                                  color: "#FF1717",
                                  borderRadius: "18px",
                                }}
                                size="sm"
                                type="button"
                                onClick={(e) =>
                                  editField(
                                    2,
                                    "approval",
                                    item.month_ye,
                                    item.user_id,
                                    i
                                  )
                                }
                                
                              >
                                Reject
                              </Button>
                           
                            </td>
                      ) : <>
                      <td><span
                                  color="primary"
                                  style={{
                                    color:
                                      item.approval == "1"
                                        ? "#02C779"
                                        : "#FF1717",
                                        textAlign: "center",
                                  }}
                                >{(item.approval== 1) ? 'Discussed & Approved' : (item.approval== 2) ? "Rejected" : "  "}</span>
                        </td>
                         
                      </> }
                      {(item.manager_approval != 1 && item.manager_approval != 2 && (item.status == 3 || item.status == 17) && item.approval == 1 && item.manager_id == user_info.id) ?
                            (<td>
                              <Button
                                color="primary"
                                style={{
                                  background: "#02C779",
                                  border: "#02C779",
                                  borderRadius: "18px",
                                }}
                                size="sm"
                                type="button"
                                onClick={(e) =>
                                  editField(
                                    1,
                                    "manager_approval",
                                    item.month_ye,
                                    item.user_id,
                                    i
                                  )
                                }
                              >
                                Approve
                              </Button>
                             
                              <Button
                                color="primary"
                                style={{
                                  border: "1px solid #FF6430",
                                  background:'none',
                                  color: "#FF1717",
                                  borderRadius: "18px",
                                }}
                                size="sm"
                                type="button"
                                onClick={(e) =>
                                  editField(
                                    2,
                                    "manager_approval",
                                    item.month_ye,
                                    item.user_id,
                                    i
                                  )
                                }
                                
                              >
                                Reject
                              </Button>
                           
                            </td>
                      ) : <>
                      <td><span
                                  color="primary"
                                  style={{
                                    color:
                                      item.manager_approval == "1"
                                        ? "#02C779"
                                        : "#FF1717",
                                        textAlign: "center",
                                  }}
                                >{(item.manager_approval== 1) ? 'Discussed & Approved' : (item.manager_approval== 2) ? "Rejected" : "  "}</span>
                        </td>
                         
                      </> }
                      <td  onClick={(item.manager_approval != 1 || item.approval != 1) ? (e) => handlemaineditRow(i) : undefined}  >
                        {item.mainediting ? (
                          <input type="text"
                          className="form-control"
                          defaultValue={item.remarks}
                          
                            onBlur={(e) =>
                              editField(
                                e.target.value,
                                "remarks",
                                item.month_ye,
                                item.user_id,
                                i
                              )
                            }
                          />
                        ) : (
                          <span>{item.remarks}</span>
                        )}
                      </td>
                            <td>
                            {(item.status != 17) ?
                      (
                            <Button className="btn btn-success" 
                            onClick={(e) =>
                              editclick(
                                item.user_id,item.month_ye
                              )
                            } class="btn btn-success"><i class="fa fa-eye"></i></Button>) : null }
                            {user_info.role_id==18?
                          <Button className="btn btn-danger" onClick={(e) => { archieveRows(e, item.id,'delete',item.user_id,item.month_year); }} ><i className="fa fa-trash"></i></Button>:null  
                          }
                            </td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      ) 
                    )
                  ) : (
                    <tr>
                      <td colSpan={3}>No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <nav aria-label="...">
                  <Pagination
                    className="pagination justify-content-end mb-0"
                    listClassName="justify-content-end mb-0"
                  >
                    <PaginationItem disabled={currentPage <= 1}>
                      <PaginationLink onClick={handlePreviousClick} previous />
                    </PaginationItem>
                    {[...Array(last_page)].map((page, i) => (
                      <PaginationItem
                        active={i + 1 === currentPage}
                        key={i + 1}
                      >
                        <PaginationLink
                          onClick={(e) => handlePageClick(e, i + 1)}
                        >
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    ))}
                    <PaginationItem disabled={currentPage >= last_page}>
                      <PaginationLink onClick={handleNextClick} next />
                    </PaginationItem>
                  </Pagination>
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default KROListing;
